<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title repayment_h1">还款计划详情<span
        class="ask-time">申请时间　{{detail.applyDate}}</span></h1>
      <div class="repayment-top">
        <dl class="text-center should-repaymen">
          <dt>应还金额</dt>
          <dd>¥{{detail.repayMoneySum | addThousandSign(2)}}</dd>
        </dl>
        <ul class="repay-details">
          <li><span>本金</span><strong>¥{{detail.principal | addThousandSign(2)}}</strong></li>
          <li><span>保理费</span><strong>¥{{detail.factoringMoney | addThousandSign(2)}}</strong></li>
          <li><span>财务服务费</span><strong>¥{{detail.factoringServiceMoney | addThousandSign(2)}}</strong></li>
          <li><span>本期应还总额</span><strong style="color:#EB662B;">¥{{detail.repayMoneySum | addThousandSign(2)}}</strong></li>
        </ul>
      </div>
      <repayment-list :infoList="detail" @getRepayList="getData"></repayment-list>
    </div>
  </section>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';
  import RepaymentList from './RepaymentList_bl.vue';
  import MyLoanApi from '../../api/myloan_bl.js';

  export default {
    components: {
      RepaymentList
    },
    data () {
      return {
        financePayId: this.$route.params.financePayId,
        financePayPeriod: this.$route.params.financePayPeriod,
        pageCurrent: 1,
        pageSize: 10,
        repayStatusCode: this.$route.params.repayStatusCode,
        detail: {} // 定义还款详情对象
      };
    },
    computed: {
      ...mapGetters({
        // detail: types.GET_NO_REPAY_DETAIL
      })
    },
    methods: {
      ...mapActions({
        getRepayPlanDetail: types.GET_REPAY_PLAN_INFO
      }),
      ...mapMutations({
        setRepayDetail: types.SET_NO_REPAY_DETAIL
      }),
      getData (currenPage) {
        if (currenPage) this.pageCurrent = currenPage;
        this.getRepayPlanDetail({
          financePayId: this.financePayId,
          financePayPeriod: this.financePayPeriod,
          pageSize: this.pageSize,
          pageCurrent: this.pageCurrent,
          repayStatusCode: this.repayStatusCode
        }).then((res) => {
          if (res.data.code === '0') {
            this.setRepayDetail(res.data.data);
          }
        });
      },
      getInfo () {
        MyLoanApi.getRepayDetails({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          financePayId: this.$route.params.financePayId,
          repayPeriod: this.$route.params.repayPeriod
        }).then((res) => {
          console.warn('okk....');
          console.warn(res);
          if (res.rspcode == 1) {
            this.detail = res.data;
          }
        }).catch((error) => {

        });
      }
    },
    mounted () {
      // this.getData()
      this.getInfo();
    }
  };
</script>
<style lang="scss">
  .ask-time {
    float: right;
    margin-top: 6px;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 10px;
    font-weight: normal;
    color: $lightSilver;
  }

  .repayment-top {
    overflow: hidden;
    background: #F5F7F8;
  }

  .should-repaymen {
    float: left;
    overflow: hidden;
    padding-top: 30px;
    border-radius: 7px;
    width: 417px;
    height: 126px;
    background: $white;

    dt {
      font-size: 18px;
      color: $orange;
      line-height: 34px;
      font-family: "FZLanTingHei_GBK";
    }

    dt:after {
      content: 'Repayment amount';
      display: block;
      color: #3E454D;
      font-size: 13px;
      line-height: 15px;
      font-family: "MyriadPro-Regular";
    }

    dd {
      font-size: 30px;
      color: #59402E;
      line-height: 44px;
      font-family: "MyriadPro-Bold";
    }
  }

  .repay-details {
    float: right;
    border-radius: 7px;
    padding: 13px;
    width: 409px;
    height: 130px;
    background: $white;

    li {
      width: 183px;
      padding-left: 20px;
      height: 64px;
      float: left;
      span {
        display: block;
        height: 26px;
        color: $lightSilver;
        font-size: 12px;
        line-height: 28px;
      }
      strong {
        display: block;
        height: 30px;
        color: $personalCenterTitleBlack;
        font-size: 20px;
        line-height: 28px;
        font-family: "MyriadPro-Bold";
      }
    }
    li:first-child {
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
    }
    li:nth-child(2) {
      border-bottom: 1px solid #eee;
    }
    li:nth-child(3) {
      border-right: 1px solid #eee;
    }
    li:last-child strong {
      color: $personalCenterFormLabel;
    }
  }

  .repayment-tips {
    overflow: hidden;
    margin: 27px 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    text-indent: 30px;
    background: #E6E9EA url('../../../static/images/icons/failed_alert_icon.png') no-repeat 8px center;
    background-size: 16px;
    font-family: "FZLanTingHei_GBK";
  }
</style>



// WEBPACK FOOTER //
// RepaymentInfo_bl.vue?ee10b42e